<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :destroyOnClose="true"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        
        <a-form-model-item :label="language['parentNode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="pid">
          <j-category-select-prevent ref="treeSelect" v-model="model.pid" :currid="currid" ></j-category-select-prevent>
        </a-form-model-item>

        <a-form-model-item :label="language['categoryName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
          <a-input v-model="model.name" :placeholder="language['common.pleaseInput']+language['categoryName']" style="width: 85%"></a-input>
          <a-button @click="languageModelOpen('EpBdCategory','name',categoryNameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
        </a-form-model-item>
        <a-form-model-item :label="language['categoryCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code">
          <a-input v-model="model.code" :placeholder="language['common.pleaseInput']+language['categoryCode']"></a-input>
        </a-form-model-item>

        <a-form-model-item :label="language['plat_ExecutiveLevel']" :labelCol="labelCol" :wrapperCol="wrapperCol"  prop="level">
          <j-dict-select-tag type="list" v-model="model.level" dictCode="plat_ExecutiveLevel" :placeholder="language['common.pleaseInput']+language['plat_ExecutiveLevel']" />
        </a-form-model-item>
        <a-form-model-item :label="language['system.longitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input v-model="model.longitude" ></a-input>
        </a-form-model-item>
        <a-form-model-item :label="language['system.latitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input v-model="model.latitude" ></a-input>
        </a-form-model-item>
        <a-form-model-item :label="language['system.altitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input v-model="model.altitude" ></a-input>
        </a-form-model-item>
        <a-form-model-item :label="language['system.isVirtual']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-radio-group v-model="model.virtual" >
            <a-radio value="1" >
              {{language['common.yes']}}
            </a-radio>
            <a-radio value="0" >
              {{language['common.no']}}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :label="language['portal.unitSortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
          <a-input-number v-model="model.sortNo" :placeholder="language['common.pleaseInput']+language['portal.unitSortNo']" style="width: 100%" :min="1" :max="999999" :disabled="disableSubmit"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-modal>
</template>

<script>

  import { httpAction,getAction } from '@/api/manage'
  import JCategorySelectPrevent from './JCategorySelectPrevent'
  import LanguageModel from "@/components/LanguageModel"
  
  import { validateDuplicateValue } from '@/utils/util' 

  export default {
    name: "EpProvinceListModal",
    components: {
      JCategorySelectPrevent,LanguageModel
    },
    data () {
      return {
        title:"操作",
        width:800,
        visible: false,
        model: {},
        currid:'',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        url: {
          list: "/sys/province/categoryList",
          add: "/sys/province/add",
          edit: "/sys/province/edit",
          checkCode:"/sys/province/checkCode",
        },
        expandedRowKeys:[],
        pidField:"pid",
        subExpandedKeys:[],
        pCategoryOptions:[],
        categoryNameLanguages:[],
      }
    },
    created () {      
      this.loadData(1)
    },
    computed : {
      disabled() {
          return this.model.id?true : false;
      },
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        if (this.language) {
          return {
            pid:{},
            name: [{ required: true, message: this.language['common.pleaseInput']+this.language["common.name"] },
                  {max: 200, message: this.language['selfCheck.remark.limit'], trigger: 'blur'},
            ],
            code: [{ required: true, message: this.language['common.pleaseInput']+this.language["common.code"] },
                  {max: 60, message: this.language['plat.categoryCode.length.limit'], trigger: 'blur'},
                 { validator: (rule, value, callback) => validateDuplicateValue('ep_bd_category', 'code', value, this.model.id,'0', callback)},
            ],
            level:[{ required: true, message: this.language['plat_SelectAdministrativeLevel'] } ],
          }
        }
      },
    },
     methods: {
       languageModelOpen(dataTable,dataColumn,languagelist){
         this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist);
       },
       languageOk(map){
         if(map&&map.dataColumn == 'name'){
           this.categoryNameLanguages = map.languagelist;
         }
       },
       getDataByResult(result){
         if(result && result.length>0){
           return result.map(item=>{
             //判断是否标记了带有子节点
             if(item[this.hasChildrenField]=='1'){
               let loadChild = { id: item.id+'_loadChild', name: 'loading...', isLoading: true }
               item.children = [loadChild]
             }
             return item
           })
         }
       },
        loadData(arg){
          this.loading = true
          let params = {pageNo:1,pageSize:100000};
          return new Promise((resolve) => {
            getAction(this.url.list,params).then(res=>{
              if(res.success){
                let result = res.result
                if(Number(result.total)>0){                
                  this.pCategoryOptions = this.getDataByResult(res.result.records)
                }
              }else{
                this.$message.warning(res.message)
              }
            }).finally(()=>{
              this.loading = false
            })
          })
        },
        add () {
          this.edit({});
        },
       initLanguagetemp(dataTable,dataColumn,dataId){
         getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
           if (res.success) {
             this.categoryNameLanguages = res.result;
           }
         })
       },
        edit (record) {
          this.model = Object.assign({}, record);
          this.currid = this.model.id;
          this.visible = true;
          this.initLanguagetemp('EpBdCategory','name',this.model.id);
        },
        close () {
          this.$emit('close');
          this.visible = false;
          this.$refs.form.resetFields();
        },
        handleOk () {
          const that = this;
          // 触发表单验证
          this.$refs.form.validate(valid => {
            if (valid) {
              that.confirmLoading = true;
              let httpurl = '';
              let method = '';
              if(!this.model.id){
                httpurl+=this.url.add;
                method = 'post';
              }else{
                httpurl+=this.url.edit;
                 method = 'put';
              }
              httpAction(httpurl,this.model,method).then((res)=>{
                if(res.success){
                  this.categoryNameLanguages.forEach(item=>{
                    if(!item.dataId){
                      item.dataId = res.result.id;
                    }
                  })
                  httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.categoryNameLanguages,"post").then((res)=>{
                    if(res.success){
                      that.$message.success(res.message);
                      // close的时候清空了表单的值 导致model为空 修改值在列表页没有变 此处需要复制一下model
                      that.submitSuccess({...this.model})
                    }
                  })
                }else{
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }else{
              return false;
            }
      
          })
        },
        handleCancel () {
          this.close()
        },
        submitSuccess(formData){
          if(!formData.id){
            let treeData = this.$refs.treeSelect.getCurrTreeData()
            this.expandedRowKeys=[]
            this.getExpandKeysByPid(formData[this.pidField],treeData,treeData)
            if(formData.pid && this.expandedRowKeys.length==0){
              this.expandedRowKeys = this.subExpandedKeys;
            }
            this.$emit('ok',formData,this.expandedRowKeys.reverse());
          }else{
            this.$emit('ok',formData);
        }
        },
        getExpandKeysByPid(pid,arr,all){
          if(pid && arr && arr.length>0){
            for(let i=0;i<arr.length;i++){
              if(arr[i].key==pid){
                this.expandedRowKeys.push(arr[i].key)
                this.getExpandKeysByPid(arr[i]['parentId'],all,all)
              }else{
                this.getExpandKeysByPid(pid,arr[i].children,all)
              }
            }
          }
        },
      
      }
  }
</script>